import clear from 'utils/clear';

export const initCountryPicker = (select: HTMLSelectElement) => {
  clear(select);

  window.theme.languages.forEach((language) => {
    select.insertAdjacentHTML(
      'beforeend',
      `<option value="${language.locale}">${language.flagIcon} ${language.name}</option>`,
    );

    language.subLocales?.forEach((subLocale) => {
      select.insertAdjacentHTML(
        'beforeend',
        `<option value="${subLocale.locale}" data-is-sub-locale="${language.locale}">
          ${language.name} (${subLocale.currency})
        </option>`,
      );
    });
  });
};

export default {
  initCountryPicker,
};
